module.exports = __webpack_public_path__ + "img/brand-pic1-02.e7d86512.png";